module.exports = __webpack_public_path__ + "static/social-health-enterprise-862084687e0b0247c167752bb79e9119.png";